(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("switch", [], factory);
	else if(typeof exports === 'object')
		exports["switch"] = factory();
	else
		root["switch"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 